<template>
  <v-btn
    v-if="canManage"
    variant="text"
    icon
    class="mr-4"
    data-cy="org-settings-gear"
    @click="goOrgSettings"
  >
    <v-icon>mdi-cog-outline</v-icon>
    <v-tooltip activator="parent" location="bottom">Organization settings</v-tooltip>
  </v-btn>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

const store = useStore()
const router = useRouter()

const currentOrgId = computed(() => store.getters['currentOrg/currentOrgId'])
const isSuperAdmin = computed(() => store.state.isSuperAdmin)

// Owners and SuperAdmins see the gear; members/viewers don't.
const canManage = computed(() =>
  !!currentOrgId.value && (isSuperAdmin.value || store.getters['orgMembers/isOrgOwner'](currentOrgId.value))
)

const goOrgSettings = () => {
  if (currentOrgId.value) {
    router.push(`/org/${currentOrgId.value}/admin`).catch(() => {})
  }
}
</script>
